/* ==========================================================================
  editor-gutenberg.js
========================================================================== */

/**
 * Modify style variants.
 */
wp.domReady(function () {
  // disable default variants
  wp.blocks.unregisterBlockStyle("core/button", "outline");
  wp.blocks.unregisterBlockStyle("core/button", "squared");
  wp.blocks.unregisterBlockStyle("core/image", "circle-mask");
  wp.blocks.unregisterBlockStyle("core/quote", "large");
  wp.blocks.unregisterBlockStyle("core/separator", "dots");
  wp.blocks.unregisterBlockStyle("core/separator", "wide");
  wp.blocks.unregisterBlockStyle("core/table", "stripes");

  // core/paragraph
  wp.blocks.registerBlockStyle("core/paragraph", {
    name: "lead",
    label: "Lead paragraph",
  });

  // core/button
  wp.blocks.registerBlockStyle("core/button", {
    name: "green-light",
    label: "Vaaleanvihreä",
  });

  // core/button
  wp.blocks.registerBlockStyle("core/button", {
    name: "green-light-transparent",
    label: "Vaaleanvihreä läpinäkyvä",
  });

  // core/button
  wp.blocks.registerBlockStyle("core/button", {
    name: "green-dark",
    label: "Tummanvihreä",
  });

  // core/button
  wp.blocks.registerBlockStyle("core/button", {
    name: "green-dark-transparent",
    label: "Tummanvihreä läpinäkyvä",
  });

  // core/button
  wp.blocks.registerBlockStyle("core/button", {
    name: "ghost",
    label: "Pelkkä alleviivaus",
  });

  // core/button
  wp.blocks.registerBlockStyle("core/button", {
    name: "ghost--white-underline",
    label: "Pelkkä alleviivaus (valkoinen)",
  });

  // core/image
  wp.blocks.registerBlockStyle("core/image", {
    name: "droplet-decoration",
    label: "Pisarakoriste",
  });

  // core/group
  wp.blocks.registerBlockStyle("core/group", {
    name: "bg-color-pink",
    label: "Kajo",
  });

  // core/group
  wp.blocks.registerBlockStyle("core/group", {
    name: "bg-color-green-dark",
    label: "Metsä",
  });

  // core/group
  wp.blocks.registerBlockStyle("core/group", {
    name: "bg-color-green-light",
    label: "Niitty",
  });

  // core/group
  wp.blocks.registerBlockStyle("core/group", {
    name: "bg-color-purple-light",
    label: "Purkka",
  });

  // core/group
  wp.blocks.registerBlockStyle("core/group", {
    name: "bg-color-lilac-light",
    label: "Ranta",
  });

  // core/group
  wp.blocks.registerBlockStyle("core/group", {
    name: "bg-color-yellow-light",
    label: "Sitrus",
  });

  wp.blocks.registerBlockStyle("core/columns", {
    name: "divider",
    label: "Pystyviiva",
  });

  wp.blocks.registerBlockStyle("core/columns", {
    name: "fixed-width",
    label: "Kiinteä leveys, 3 rinnakkain",
  });

  wp.blocks.registerBlockStyle("core/heading", {
    name: "small-heading",
    label: "Pieni otsikko",
  });

  wp.blocks.registerBlockStyle("acf/contact-persons", {
    name: "layout-row",
    label: "Rivi",
  });

});

/**
 * Modify featured image size
 */
wp.hooks.addFilter(
  "editor.PostFeaturedImage.imageSize",
  "unfair-starter/alter-featured-image-size",
  function (size, attachment_id, post_id) {
    return "medium";
  }
);
function addBlockAnchor(settings, name) {
  if (name !== "core/details") {
    return settings;
  }

  var newSettings = Object.assign({}, settings);
  newSettings.supports = Object.assign({}, settings.supports);
  newSettings.supports.anchor = true;
  newSettings.attributes = Object.assign({}, settings.attributes);
  newSettings.attributes.anchor = { type: "string" };

  return newSettings;
}
wp.hooks.addFilter(
  "blocks.registerBlockType",
  "norpel-blocks/addBlockAnchor",
  addBlockAnchor
);
